/**
 * Which logo file the photo page shows.
 *
 * `logo.png` (si, and the identical hr/pl/sk files) has dark-grey "FOTO"
 * letters (#555) that all but vanish on the dark theme's near-black page.
 * `logo.dark.png` is the same artwork with the letters at #E6E6E6 and the
 * teal aperture untouched. The at/cz/it logo is teal letters around a grey
 * aperture, which reads on both grounds, so it has no dark variant.
 */
const GREY_LETTER_LOCALES = new Set(["si", "hr", "pl", "sk"]);

export function logoSrc(
  locale: string | undefined,
  mode: "light" | "dark",
): string {
  if (mode === "dark" && (!locale || GREY_LETTER_LOCALES.has(locale))) {
    return "/images/logo/logo.dark.png";
  }
  return `/images/logo/logo${locale && locale !== "si" ? `.${locale}` : ""}.png`;
}
